<template>
  <LogoutBtn :auth-model="model" :title="title" @on-logout="useLogout" />
</template>

<script lang="ts" setup>
  // Types
  import type { TCompany, TUser, IAuthModel } from '~/misc/auth/types';
  import type { TAuthStore } from '~/modules/auth/store/types';

  // Store
  import { useAuthStore } from '~/modules/auth/store';

  // Models
  import { AuthModel } from '~/modules/auth/models/auth';

  // Composables
  import { useLogout } from '~/modules/auth/composables/use-logout';

  // Components
  import LogoutBtn from '~/misc/btn/logout/LogoutBtn.vue';

  const authStore: TAuthStore = useAuthStore();

  const model: IAuthModel = new AuthModel();

  const user: ComputedRef<TUser | null> = computed<TUser | null>(() => authStore.user);

  const title: ComputedRef<string> = computed<string>(() => {
    if (!user.value) return 'Logout';

    const company: TCompany = user.value.company;

    return `${user.value.name}${company ? ` / ${company.name}` : ''} (logout)`;
  });
</script>
